import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from "@angular/core";
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import {
  IssueHistory,
  IssueRecordFilter,
  IssueTrackingPayload
} from '@k12/models';
import { IIssueTrackingService } from '@k12/admin-services';

@Injectable({
  providedIn: 'root'
})
export class IssueTrackingService implements IIssueTrackingService {
  private http = inject(HttpClient);

  public getIssueRecords(filter: IssueRecordFilter): Observable<IssueHistory[]> {
    return this.http.post<IssueHistory[]>(
      `${environment.adminApiUrl}/schools/issueRecords`,
      filter
    );
  }

  public getIssueRecordsPageForUserRecord(filter: IssueRecordFilter): Observable<IssueHistory[]> {
    return this.getIssueRecords(filter);
  }

  public saveIssueTracking(payload: IssueTrackingPayload): Observable<IssueHistory> {
    return this.http.post<IssueHistory>(
      `${environment.adminApiUrl}/schools/issueRecord`,
      payload
    );
  }
}
